import React from 'react'

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 86 8"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M87 4C87 1.79086 85.2091 0 83 0H0V8H83C85.2091 8 87 6.20914 87 4Z"
      fill={fill}
    />
  </svg>
);

export default SVG;